VjsAdmin.LicenseAddForm = (function () {
    const init = function () {
        VjsAdmin.initDateRangePickers($('#license-add-form'));

        // convert database date from UTC to local time
        if (
            typeof $('#activation_date').val() !== 'undefined'
            && $('#activation_date').val() !== null
            && $('#activation_date').val() !== ''
        ) {
            $('#activation_date').val(moment($('#activation_date').val()).format('MM/DD/YYYY'));
        }
        if (
            typeof $('#expiration_date').val() !== 'undefined'
            && $('#expiration_date').val() !== null
            && $('#expiration_date').val() !== ''
        ) {
            $('#expiration_date').val(moment($('#expiration_date').val()).format('MM/DD/YYYY'));
        }

        // convert submitted dates from local timezone to UTC
        $('form#license-add-form').submit(() => {
            if (
                typeof $('#activation_date').val() !== 'undefined'
                && $('#activation_date').val() !== null
                && $('#activation_date').val() !== ''
            ) {
                $('#activation_date').val(moment($('#activation_date').val()).format());
            }
            if (
                typeof $('#expiration_date').val() !== 'undefined'
                && $('#expiration_date').val() != null
                && $('#expiration_date').val() !== ''
            ) {
                $('#expiration_date').val(moment($('#expiration_date').val()).format());
            }
        });

        $('#grade_ids').multiselect({
            enableClickableOptGroups: true,
        });
        $('#user_access_grade_ids').multiselect({
            enableClickableOptGroups: true,
        });
    };

    return {
        init,
    };
}());
